<template>
	<!-- star -->

	<div class="youjiaopage_wrap">
		<nav2></nav2>
		<banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
		<!-- 面包屑 -->
<!--		<div class="Crumbs">-->
<!--			<div>当前位置：首页><span>金融</span></div>-->
<!--		</div>-->
		<!--  -->
		<div class="NewsDetails">
			<div class="NewsDetails_cont">
				<div class="NewsDetails_cont_title">
					<h1>2024人工智能大会：面向未来，迎接挑战</h1>
					<div class="NewsDetails_cont_title_span">
						<img src="../../assets/img/newsDetail/矩形.png" alt="" /><span
							>发布时间：2024-09-25
						</span>
<!--						<img src="../../assets/img/newsDetail/矩形(1).png" alt="" /><span-->
<!--							>浏览次数：156-->
<!--						</span>-->
					</div>
				</div>
				<div class="NewsDetails_cont_text">
					<p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024年7月4日世界人工智能大会（WAIC）在上海成功举行，经国务院批准，由外交部、国家发改委、教育部、科技部、工信部、国家网信办、中科院、中科协和上海市政府共同主办。打造“会议论坛、展览展示、评奖赛事、智能体验”四大板块，聚焦人工智能领域前沿技术、产业动向、向善治理等全球人工智能行业普遍关心的领域。					</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/2024WAIC.png"
                alt=""
            />
          </div>
<!--					<div>大会亮点</div>-->
					<p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;自2018年首次举办以来，世界人工智能大会（WAIC）已成为全球AI领域的重要盛事。它不仅展示了中国在AI技术上的快速发展，也促进了全球科技的交流与合作。2024年的WAIC在AI技术迅猛发展和全球经济转型的大背景下，以"以共商促共享 以善治促善智"为主题，深入探讨了AI伦理、治理和应用，强调了AI技术在服务人类社会中的积极作用，体现了推动全球AI健康发展和国际合作的共同愿景。一起来看一下此次大会都有哪些亮点吧！					</p>
					<p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本届大会较往届持续扩容升级，展览面积达到5.2万平方米，创下历史之最，以"以共商促共享 以善治促善智"为主题，吸引了特斯拉、微软等500余家企业参展，其中市外企业和国际企业的占比超过了50%，重点围绕核心技术、智能终端、应用赋能三大板块，聚焦大模型、算力、机器人、自动驾驶等重点领域，展出1500多项创新技术和产品。					</p>
					<p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;创新性地采用"1+3+10+X"论坛架构，深入讨论AI伦理、大模型等关键议题；"1"代表开幕式：作为大会的开端，开幕式通常包含重要嘉宾的致辞、主题演讲和大会的总体介绍，为接下来的论坛活动定下基调。"3"指的是三场全体会议：这三场全体会议通常聚焦于人工智能领域的全球治理、产业发展和科学前沿等宏观议题，为与会者提供行业发展的全局视角。"10"代表十个主题论坛：这些论坛深入探讨AI伦理治理、大模型技术、数据安全、算力发展、具身智能、AI for Science、智慧工业、自动驾驶、投融资以及教育与人才培养等十个关键领域，每个论坛都围绕一个特定主题进行深入交流和讨论。"X"表示多个分论坛和圆桌讨论："X"代表数量可变的分论坛和圆桌讨论，它们提供了更为灵活和多样化的讨论平台，可以覆盖更广泛的子主题和新兴议题，允许与会者根据兴趣选择参与不同的讨论。					</p>
					<p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过六大智能体验场景提供沉浸式体验，让与会者直观感受AI技术的应用；汇聚全球领军人物，增强国际交流与合作，展现中国在AI领域的创新成就；					</p>
					<p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过"三奖三赛"等活动激发创新激情引领风向，培养和吸引AI领域人才，为全球人工智能的发展贡献中国智慧和上海方案。</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大会汇聚了腾讯、百度、阿里还有华为等行业巨头，首发新品超50款，首发新品数突破了历史纪录。其中，新一代模型方面，商汤科技将首发“商汤日日新5.5”，科大讯飞“讯飞星火大模型V4.0”将迎来首秀。模型应用中，蚂蚁集团“基于蚂蚁百灵大模型的‘支付宝智能助理’”、金山办公“WPS AI 企业版”将亮相。展示出了大模型在金融、医疗还有政务等多个场景强大的应用潜力，面对大模型的研发和应用的挑战，大会举办了科学前沿的全体大会，针对关键问题，探索了AI时代的未来路径，通过大模型在大会上展现的技术突破和应用的潜力，推动了各行各业智能化的转型。这些模型的发展将开启人工智能的新篇章。</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本届大会还重点打造了人形机器人专区，在世博的展厅的中厅，有15款18台的人形机器人，组成了一个阵列展示才艺，与观众进行互动，不再是原来的传统机器人，充分展示了机器人技术的系统效应，以及在“异构群智”领域的一个重大突破。超过40款的智能机器人亮相展厅，25款为人形机器人，特斯拉人形机器人擎天柱二（Optimus）、达闼双足人形机器人XR4首发首秀。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/img_1.png"
                alt=""
            />
          </div>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;值得一提的是国内首款全尺寸人形机器人“青龙”，以一米八的身高以及灵活的手指操作能力，展示了其卓越的能力，“青龙”全身有43个关节，不仅腿脚快还能躲避障碍，它的双手非常灵活，能精准抓取2厘米的小物件，还能使用工具在小米里挑芝麻，国家地方共建人形机器人创新中心总经理许彬表示，“青龙”之所以这么聪明，在于和大模型的深度融合，负责人机交互和决策的“大脑”大模型和负责稳定行走的“小脑”大模型形成人形机器人的技术基座，开源社区也已发布，为机器人的技术创新和发展注入了新的活力。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/img_2.png"
                alt=""
            />
          </div>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;央企和国企的“AI+”战略，在此次大会上也见证了中国的国有企业在人工智能领域的创新力量，中国移动、中国联通、中国电信等展示了“九天基座大模型”，还有“5G-A X AI新通话”“元景1+1+M”的大模型在国内技术的应用，此次大会还举办了中国人工智能产业的创新成果展，以“人工智能赋能新型的工业化”为主题，邀请了60多家的企业参展，全面展示了中国的AI技术在产业治理方面的最新的发展和成效。</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京弘易信泰科技发展有限公司受邀参会，通过贴近客户需求，优化人工智能信息化解决方案，为更好服务客户打基础。北京弘易信泰科技发展有限公司是一家专注软件与信息服务的创新型企业，应用大数据、人工智能、云计算技术，开发交付数据治理解决方案，助力客户信息化业务。          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大会汇聚了腾讯、百度、阿里还有华为等行业巨头，首发新品超50款，首发新品数突破了历史纪录。其中，新一代模型方面，商汤科技将首发“商汤日日新5.5”，科大讯飞“讯飞星火大模型V4.0”将迎来首秀。模型应用中，蚂蚁集团“基于蚂蚁百灵大模型的‘支付宝智能助理’”、金山办公“WPS AI 企业版”将亮相。展示出了大模型在金融、医疗还有政务等多个场景强大的应用潜力，面对大模型的研发和应用的挑战，大会举办了科学前沿的全体大会，针对关键问题，探索了AI时代的未来路径，通过大模型在大会上展现的技术突破和应用的潜力，推动了各行各业智能化的转型。这些模型的发展将开启人工智能的新篇章。</p>
        </div>


<!--				<div class="NewsDetails_cont_btm">-->
<!--					<div>相关新闻</div>-->
<!--					<p>更多 ></p>-->
<!--				</div>-->
<!--				<div class="NewsDetails_cont_btm2">-->
<!--					<div class="NewsDetails_cont_btm2_1">-->
<!--						<div>发展数字经济 共享包容增长 为经济发展插上“数字翅膀”</div>-->
<!--						<p>2021-05-30</p>-->
<!--						<p>-->
<!--							中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...-->
<!--						</p>-->
<!--					</div>-->
<!--					<div class="NewsDetails_cont_btm2_1" style="background: #f8f8f8">-->
<!--						<div>发展数字经济 共享包容增长 为经济发展插上“数字翅膀”</div>-->
<!--						<p>2021-05-30</p>-->
<!--						<p>-->
<!--							中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...-->
<!--						</p>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</div>

		<footer2></footer2>

		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../../components/footer.vue";
import banner2 from "../../components/banner.vue";
import nav2 from "../../components/nav.vue";
export default {
	name: "new1",
	components: {
		footer2,
		nav2,
		banner2,
	},
	// data() {
	// 	return {
	// 		h1: "企业新闻",
	// 		Img1: require("../../assets/img/keji/矿山banner1.png"),
  //
	// 		p1: "更多最新精彩资讯，感受企业魅力",
	// 	};
	// },
	methods: {},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
  //font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  text-align: left;
}
/*字体 文本居左*/
ul {
  list-style: none;
}
/*去ul li 小点*/
img {
  border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}
/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}
/*清浮动*/
a {
  color: #000000;
}
/*==========================Reset_End===========================*/

.youjiaopage_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}
/* 面包屑 */
.Crumbs {
  width: 1200px;
  height: 46px;
  margin: 0 auto;
}
.Crumbs {
  font-size: 12px;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.Crumbs div {
  line-height: 46px;
}
.Crumbs span {
  color: #000000;
}
/* 新闻详情 */
.NewsDetails_cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px ;
  border-top: 1px solid #eaeaea;
}
.NewsDetails_cont_title > h1 {
  font-size: 28px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 800;
  color: #2b2b2b;
  line-height: 33px;
  margin-top: 78px;
  text-align: center;
}
.NewsDetails_cont_title img {
  vertical-align: middle;
}
.NewsDetails_cont_title_span {
  text-align: center;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a3a3a3;
  line-height: 30px;
  margin-top: 20px;
}
.NewsDetails_cont_text {
  //margin-top: 40px;
  //border-top: 1px solid #eaeaea;
  font-family: AlibabaPuHuiTi-3-55-Regular;
}
.NewsDetails_cont_text p {
  line-height: 28px;
  width: 1000px;
  margin: 40px 100px;
  font-size: 16px;
  font-weight: lighter;
}
.NewsDetails_cont_text div {
  line-height: 24px;
  margin-left: 90px;
  font-size: 24px;
  font-weight: bold;
}
.NewsDetails_cont_img {
  width: 1000px;
  text-align: center;
  margin-bottom: 40px;

}
.NewsDetails_cont_footer {
  padding: 0 40px;

  line-height: 68px;
  width: 1120px;
  height: 68px;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm div {
  font-size: 24px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #222222;
  line-height: 33px;
}
.NewsDetails_cont_btm p {
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.NewsDetails_cont_btm2 {
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm2_1 {
  margin: 32px 0;
  padding: 31px 61px 31px 20px;
  width: 507px;
  height: 123px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
}
.NewsDetails_cont_btm2_1 div {
  font-size: 18px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
}
.NewsDetails_cont_btm2_1 p {
  margin-top: 10px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
</style>